import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('braintree-token',{attrs:{"tokenization-key":_vm.paymentMethod.tokenizationKey},on:{"token":function($event){return _vm.$emit('token', { payment_method_nonce: $event.nonce })}},scopedSlots:_vm._u([{key:"after",fn:function(ref){
var submit = ref.submit;
return [_c('div',{staticClass:"d-flex justify-end"},[_c(VBtn,{attrs:{"depressed":"","color":"primary"},on:{"click":submit}},[_c('span',[_vm._v(_vm._s(_vm.t('Proceed')))])])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }